import parentConfig from 'config';

export default {
  ...parentConfig,

  localeCodes: ['de-AT', 'en'],

  customerSupport: {
    email: 'support@propnow.com',
    phone: '+49 30 959992518',
  },

  buyerTypes: ['private', 'entrepreneurs', 'company'],

  ownershipTypes: ['sole', 'residential', 'share'],

  roundTypes: ['incremental_auction', 'sealed_bidding', 'simple_offer'],
  roundTypeBadges: {
    simple_offer: [],
  },
  roundCostHighlight: {
    simple_offer: true,
  },

  documentTypes: [
    'expose',
    'land_register',
    'building_permit',
    'usage_permit',
    'completion_display',
    'area_allocation_plan',
    'energy_certificate',
    'condominium_contract',
    'appraisal',
    'annual_statement',
    'running_costs',
    'operating_costs',
    'promissory_note',
    'loan_agreement',
  ],

  uploadTypes: ['identity_document', 'proof_of_financial_resources'],
  defaultUploadTypes: ['identity_document'],
  requiredUploadTypes: [],

  roundShowRedButtonPrice: true,

  allowConditionsInRounds: ['incremental_auction', 'simple_offer'],

  getRegistrationScheme(sale, t) {
    let scheme = parentConfig.getRegistrationScheme.call(this, sale, t);
    return scheme;
  },

  createOffer(sale, round) {
    let offer = parentConfig.createOffer.call(this, sale, round, false);
    return offer;
  },
};



// WEBPACK FOOTER //
// ./src/app/@remax-at/config.js